import { render, staticRenderFns } from "./ChapterCategoryModal.vue?vue&type=template&id=6c1dc78c&scoped=true&lang=pug"
import script from "./ChapterCategoryModal.vue?vue&type=script&lang=js"
export * from "./ChapterCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./ChapterCategoryModal.vue?vue&type=style&index=0&id=6c1dc78c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1dc78c",
  null
  
)

export default component.exports